import React from 'react';
import { connect } from 'react-redux'
import { Checkbox, Collapse } from 'antd';
import CatalogInGraphCount from '../widgets/CatalogInGraphCount';

const Panel = Collapse.Panel;

/** Сформировать условия для отбора или снятия отбора  */
function makeGraphCondition (graph) {
  return {
    predicate: undefined, 
    operator: "in", 
    value: graph, 
    alias:"graph", 
    label: graph,
    type: "uri",    
    //Переменная, к которой используется условие. см. addAliasInWhere в virtuoso/filter.js
    variable: "graph"
  };
};

/** Проверка на установку галки в чекбоксе */
const hasChecked = (graph, selected) =>{
  return (selected)? selected.filter(
    item => (Array.isArray(item.value)?item.value.indexOf(graph)>=0:item.value==graph)
  ).length>0: false;  
}

/** Отображение фильтра по URI графам, которые могут использоваться для фильтрации.*/
class CatalogsFilter extends React.Component {	

  onChangeGraph(e, graph) {
    e.preventDefault();    
    const {onChange, selected, view} = this.props;
    const condition = makeGraphCondition(graph);
    if (onChange) 
      onChange(e.target.checked, condition);    
  };

  onChangeНighlight(e){
    e.preventDefault();
  };

  render() {
    const {graphs, selected} = this.props;    
    return (
      <span className="csi_taxonomy" >
        <Collapse defaultActiveKey={['1', '2']} >        
        <Panel header={"Графы"} key="1" onClick={(e) => e.stopPropagation()}>
        {graphs && graphs.map((graph, i) => { 
          const isChecked = hasChecked(graph, selected);
          return (
            <p key={i}>
              <Checkbox checked={isChecked} onChange={(e) => this.onChangeGraph(e, graph)}>
                {graph}&nbsp;{<CatalogInGraphCount graph={graph} />}
              </Checkbox>
            </p>
          )
        })}        
        </Panel>
        </Collapse>
      </span>
    )
  }
}

export default CatalogsFilter;